import { Route, Routes as RoutesContainer } from 'react-router';
import { IDCard, Create, Edit, PrintIDCard, Show, AgentIDCard } from '../index';
import PrintRankCard from '../Pages/PrintRankCard';

const Routes = () => {
  return (
    <RoutesContainer>
      <Route exact path='/id-card' element={<IDCard />} />
      <Route exact path='/id-card/create' element={<Create />} />
      <Route exact path='/id-card/edit/:id' element={<Edit />} />
      <Route exact path='/id-card/competition/:id' element={<PrintIDCard />} />
      <Route
        exact
        path='/id-card/competition/:id/agent'
        element={<AgentIDCard />}
      />
      <Route
        exact
        path='/id-card/competition/:id/rank'
        element={<PrintRankCard />}
      />
      <Route
        exact
        path='/id-card/competition/:competitionId/user/:userId'
        element={<Show />}
      />
    </RoutesContainer>
  );
};
export default Routes;
